import React, {ReactElement, ReactNode} from 'react';
import {Flex} from 'antd';
import PageHeaderTitle from '../../../../core/Header/PageHeader/PageHeaderTitle';

type AdminSpaceHeaderProps = {
  Search?: ReactElement<any>;
  label?: string;
  Icon?: ReactNode;
  ActionButton?: ReactElement<any>;
};

const Header: React.FC<AdminSpaceHeaderProps> = ({Search, Icon, label, ActionButton}) => {
  return (
    <div className="pageHeader">
      <Flex justify="space-between" align="flex-start" gap="24px" style={{width: '100%', alignItems: 'center'}}>
        <div style={{flex: '0 0 auto', color: '#00857c'}}>
          <PageHeaderTitle title="Externalization" label={label || 'Search and register external users'} Icon={Icon} />
        </div>
        <Flex gap="16px" align="center">
          <div style={{flex: 1}}>{Search}</div>
          <div style={{flexShrink: 0}}>{ActionButton}</div>
        </Flex>
      </Flex>
    </div>
  );
};

export default Header;
